import styled from 'styled-components'

export const ItemWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
  & > svg > path {
    fill: ${props => props.theme.colors.defaultGreen};
  }
  & > p {
    text-align: center;
  }
`
